import { render } from "./hot.vue?vue&type=template&id=42bde020&scoped=true"
import script from "./hot.vue?vue&type=script&lang=js"
export * from "./hot.vue?vue&type=script&lang=js"

import "./hot.vue?vue&type=style&index=0&id=42bde020&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42bde020"]])

export default __exports__